module.exports = __webpack_public_path__ + "img/ico_sf.f71a0b10.png";